import type { ModuleRoute } from '../types';
import { DeviceDetailPage } from './DeviceDetailPage';
import { DevicesPage } from './DevicesPage';

/** Pages of this area. Owned by Phase 1 task W5; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/devices', element: <DevicesPage />, permission: 'devices.view' },
  { path: '/manage/devices/:id', element: <DeviceDetailPage />, permission: 'devices.view' },
];
